import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import EpixBoxesTableRow from './EpixBoxesTableRow';
import SortIcons from '../../ProposalsSortIcons';

const EpikBoxesTable = ({ boxesList, selectedCompany, deleteMode, sortValue, onSort }) => {
  const onHeaderKey = (e, sortName) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSort(sortName);
    }
  };
  return (
    <div className="table-header-fixed">
      <table>
        <caption className="sr-only"></caption>
        <thead>
          <tr>
            <th
              scope="col"
              className="cursor-pointer"
              onClick={() => onSort('Company[0][name]')}
              tabIndex={0}
              aria-label="Sort by Company"
              onKeyDown={(e) => onHeaderKey(e, 'Company[0][name]')}
            >
              Company
              <SortIcons sortObj={sortValue} sortName="Company[0][name]" />
            </th>

            <th
              scope="col"
              className="cursor-pointer"
              onClick={() => onSort('total')}
              tabIndex={0}
              aria-label="Sort by Total Edge Devices"
              onKeyDown={(e) => onHeaderKey(e, 'total')}
            >
              Total Edge Devices <SortIcons sortObj={sortValue} sortName="total" />
            </th>

            <th
              scope="col"
              className="cursor-pointer"
              onClick={() => onSort('online')}
              tabIndex={0}
              aria-label="Sort by Registered"
              onKeyDown={(e) => onHeaderKey(e, 'online')}
            >
              Registered <SortIcons sortObj={sortValue} sortName="online" />
            </th>

            <th
              scope="col"
              className="cursor-pointer"
              onClick={() => onSort('offline')}
              tabIndex={0}
              aria-label="Sort by Unregistered"
              onKeyDown={(e) => onHeaderKey(e, 'offline')}
            >
              Un Registered <SortIcons sortObj={sortValue} sortName="offline" />
            </th>

            <th
              scope="col"
              className="cursor-pointer"
              onClick={() => onSort('unmonitored')}
              tabIndex={0}
              aria-label="Sort by Unmonitored"
              onKeyDown={(e) => onHeaderKey(e, 'unmonitored')}
            >
              Unmonitored <SortIcons sortObj={sortValue} sortName="unmonitored" />
            </th>
            {/*<th>Alarmed</th>*/}
          </tr>
        </thead>
        <tbody>
          {boxesList && boxesList.length ? (
            boxesList.map((box, i) => (
              <EpixBoxesTableRow
                deleteMode={deleteMode}
                box={box}
                key={i}
                selectedCompany={val => selectedCompany(val)}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5}>
                <Alert rowSpan={5} color="info">
                  No Edge Device Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  null,
  null,
)(EpikBoxesTable);
